export const getRandomNumber = (): string =>
  Math.random().toString().replace('.', '');
